import React from 'react'
import { Link } from 'react-router-dom'
import { Bug, Newspaper, SealCheck } from '@phosphor-icons/react'
import PropTypes from 'prop-types'

const VIPBlock = ({ user }) => {
   return (
      <div className="w-full flex flex-col gap-6 text-sm">
         <div className="bg-gray-100 p-6 md:p-6 rounded-lg">
            <SealCheck size={32} className="text-blue-500" />
            <div className="font-semibold">Gather VIP</div>
            <div className="mb-4">
               {/* eslint-disable-next-line max-len */}
               {`${user.firstName}, thank you so much for supporting Gather. It means alot to us. If you have any feedback, suggestions, ideas or questions, please don't hesistate to reach out by DM or by email at: `}
               <a href="mailto:team@gather.do" className="text-blue-500">
                  team@gather.do
               </a>
            </div>
         </div>
         <div className="flex flex-col md:grid md:grid-cols-2 gap-6">
            <Link
               to="/bugs-issues"
               className="border-2 border-solid border-gray-200 p-6 md:p-6 rounded-lg hover:bg-gray-100 hover:border-gray-300">
               <Bug size={32} className="text-blue-500" />
               <div className="font-semibold">File a Bug</div>
               <div className="my-2">
                  {/* eslint-disable-next-line max-len */}
                  Found a bug? Submit it to our Community and we&apos;ll try to fix it as soon as we
                  can.
               </div>
               <div className="inline-block px-4 py-1 bg-blue-500 rounded-full text-white text-xs hover:bg-gray-700">
                  Submit
               </div>
            </Link>
            <Link
               to="/feature-requests"
               className="border-2 border-solid border-gray-200 p-6 md:p-6 rounded-lg hover:bg-gray-100 hover:border-gray-300">
               <Newspaper size={32} className="text-blue-500" />
               <div className="font-semibold">Request a Feature</div>
               <div className="my-2">
                  {/* eslint-disable-next-line max-len */}
                  Let us know about features or improvements you&apos;d like to see in Gather.
               </div>
               <div className="inline-block px-4 py-1 bg-blue-500 rounded-full text-white text-xs hover:bg-gray-700">
                  Submit
               </div>
            </Link>
         </div>
      </div>
   )
}

VIPBlock.propTypes = {
   user: PropTypes.object.isRequired
}

export default VIPBlock
